export default "__VITE_ASSET__CM8J4gaf__"